import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SellerCodeStorageService {
  private readonly STORAGE_KEY = 'umkt_seller_code';
  private platformId = inject(PLATFORM_ID);


  get(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    const value = sessionStorage.getItem(this.STORAGE_KEY);
    return value?.trim() ? value.trim().toUpperCase() : null;
  }

  set(code: string | null | undefined): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const sanitized = (code ?? '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .substring(0, 5);

    if (!sanitized) {
      this.clear();
      return;
    }

    sessionStorage.setItem(this.STORAGE_KEY, sanitized);
  }

  clear(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
